import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetUserLicenses as GetUserLicensesQuery,
    GetUserLicensesVariables as GetUserLicensesQueryVariables,
    GetUserLicenses_user_licenses as UserLicenseInfo,
} from 'nutshell-graphql-types';

import GET_USER_LICENSES from '../queries/get-user-licenses.graphql';

export const useGetUserLicenses = (
    userId: string
): {
    isLoading: boolean;
    licenses: UserLicenseInfo[];
    errorMessage: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetUserLicensesQuery,
        GetUserLicensesQueryVariables
    >(GET_USER_LICENSES, {
        variables: {
            userId,
        },
        fetchPolicy: 'network-only',
    });

    const user = data ? data.user : null;

    return {
        isLoading: loading,
        licenses: user ? user.licenses : [],
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
